<template>
  <div class="tiktok-wrapper">
    <LazyloadPlaceholder
      v-if="loading"
      class="tiktok__lazyload-placeholder"
    />
    <EmbedsPlaceholder
      v-if="errorLoad"
      class="tiktok__error"
      :link="originUrl"
    />
    <div class="tiktok">
      <blockquote
        ref="blockquote"
        class="tiktok-embed"
        :cite="originUrl"
        :data-video-id="vid"
        :class="{ 'tiktok-embed--errored': errorLoad }"
      >
        <section></section>
      </blockquote>
    </div>
  </div>
</template>

<script lang="ts">
  import type { PropType } from 'vue';
  import { addScriptIfNeeded } from '@devhacker/shared/utils/script/addScriptIfNeeded';
  import { removeScriptIfExists } from '@devhacker/shared/utils/script/removeScriptIfExists';
  import EmbedsPlaceholder from '~/components/EmbedsPlaceholder.vue';
  import LazyloadPlaceholder from '~/components/LazyloadPlaceholder.vue';
  import type { IEmbedContent } from '~/types/common';

  export default defineNuxtComponent({
    name: 'TiktokEmbed',

    components: {
      LazyloadPlaceholder,
      EmbedsPlaceholder,
    },

    props: {
      elem: {
        type: Object as PropType<IEmbedContent>,
        required: true,
      },
    },

    data: () => ({
      url: 'https://www.tiktok.com/embed.js',
      errorLoad: false,
      loading: true,
    }),

    computed: {
      vid(): string {
        return this.elem.attributes.vid;
      },

      originUrl(): string {
        return this.elem.attributes.originUrl;
      },
    },

    mounted() {
      addScriptIfNeeded(
        this.url,
        () => {
          this.errorLoad = true;
          this.finishLoading();
        },
        this.finishLoading,
      );
    },

    beforeUnmount() {
      removeScriptIfExists(this.url);
    },

    methods: {
      finishLoading() {
        this.loading = false;
      },
    },
  });
</script>

<style lang="scss" scoped>
  .tiktok {
    &-wrapper {
      min-height: 160px;
    }
    &-embed {
      :deep() iframe {
        min-height: 310px;
      }
    }
    &__error {
      max-width: 592px;
      width: 100%;
      margin: 0 auto;
    }
  }
</style>
